import './App.css';
import React from 'react';
import Home from './routes/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Test from './routes/Test';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/test' element={<Test />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
